"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineRequestInterceptor = void 0;
const RequestInterceptor_1 = require("./RequestInterceptor");
class OfflineRequestInterceptor extends RequestInterceptor_1.RequestInterceptor {
    constructor(internetStatusManager, axios) {
        super(axios);
        this.internetStatusManager = internetStatusManager;
        this.internetStatusManager = internetStatusManager;
    }
    /**
     * Waits indefinitely until the device state is online.
     *
     * State behavior documentation:
     * - Device: ONLINE + World: ONLINE => API succeeds
     * - Device: ONLINE + World: OFFLINE => API goes through, response interceptor catches error
     * - Device: OFFLINE + World: ONLINE => API waits, overlay shows, page refresh when back online
     * - Device: OFFLINE + World: OFFLINE => API waits, overlay shows, page refresh when back online
     * - Device: UNKNOWN + World: ONLINE => API waits until terminal state reached
     * - Device: UNKNOWN + World: OFFLINE => API waits until terminal state reached
     *
     */
    onFulfilled(config) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.internetStatusManager.waitForOnline();
            return config;
        });
    }
}
exports.OfflineRequestInterceptor = OfflineRequestInterceptor;
